import { useRegisterSW } from 'virtual:pwa-register/react';

import { Button } from '../components/ui/button';

export const ReloadPrompt = () => {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      console.info('✅ Service Worker enregistré:', swUrl);

      if (r) {
        console.info('🔄 Vérification immédiate de mise à jour...');
        void r.update();

        setInterval(
          () => {
            console.info('🔄 Vérification périodique de mise à jour...');
            void r.update();
          },
          10 * 60 * 1000,
        );
      }
    },
    onRegisterError(error) {
      console.error('❌ Erreur enregistrement SW:', error);
    },
    onNeedRefresh() {
      console.warn('⚠️ Nouvelle version disponible !');
    },
    onOfflineReady() {
      console.info('✅ App prête à fonctionner offline');
    },
  });

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };
  const reload = () => {
    // vite-plugin-pwa ne recharge que si un SW contrôlait déjà la page au
    // register() (workbox `isUpdate`) — faux après un hard reload, un "clear
    // site data" ou une première visite, et le bouton ne faisait alors rien.
    // On recharge nous-mêmes, une fois le nouveau SW aux commandes : recharger
    // avant resservirait l'ancien precache.
    navigator.serviceWorker.addEventListener(
      'controllerchange',
      () => {
        window.location.reload();
      },
      { once: true },
    );
    void updateServiceWorker(true);
    // Filet : si le SW a déjà pris la main (activé depuis un autre onglet),
    // controllerchange ne viendra plus.
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };
  return (
    <div className="m-0 p-0 w-0 h-0">
      {(offlineReady || needRefresh) && (
        <div className="fixed right-0 bottom-0 m-4 p-3 border border-accent-foreground/30 shadow-xl rounded-lg text-left bg-sidebar z-10">
          <div className="mb-2">
            {needRefresh ? (
              <span>
                New content available, click on reload button to update.
              </span>
            ) : (
              <span>App ready to work offline</span>
            )}
          </div>
          <div className="flex justify-end gap-2">
            {needRefresh ? (
              // Pas de "Close" ici : dismisser laissait l'onglet sur l'ancienne
              // version jusqu'au déploiement suivant. Le moment du rechargement
              // reste choisi par l'utilisateur (formulaire en cours).
              <Button variant="destructive" onClick={reload}>
                Reload
              </Button>
            ) : (
              <Button variant="outline" onClick={close}>
                Close
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
